import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {
    fadeOut,
    fadeIn,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const htsSections = document.querySelectorAll('.horizontal-tabs-section');
    htsSections.forEach(section => {
        const tabSliders = section.querySelectorAll('.hts-tab-slider');
        const animationLine = section.querySelector('.hts-animation-line');

        tabSliders.forEach(slider => {
            const swiper = new Swiper(slider, {
                loop: false,
                slidesPerView: 'auto',
                // allowTouchMove: false,
                spaceBetween: 96,
                breakpoints: {
                    768: {
                        spaceBetween: 80,
                    },
                },
                on: {
                    init() {
                        syncActiveTab(section, this);
                        updateLine(section, animationLine);
                    },
                    slideChange() {
                        syncActiveTab(section, this);
                        // updateLine(section, animationLine);
                    },
                    transitionEnd() {
                        updateLine(section, animationLine);
                    },
                },

            });

            slider.querySelectorAll('.hts-tab-item').forEach((slide, index) => {
                slide.addEventListener('click', () => {
                    // swiper.slideTo(index);

                    slider.querySelectorAll('.hts-tab-item').forEach(s =>
                        s.classList.remove('is-active'),
                    );
                    slide.classList.add('is-active');

                    const targetId = slide.getAttribute('data-href');
                    if (targetId) {
                        activateTabContent(section, targetId);
                    }

                    if (window.innerWidth > 992) {
                        updateLine(section, animationLine);
                    }

                    // 👇 Ensure active tab is visible on small screens
                    if (window.innerWidth < 992) {
                        swiper.slideTo(index);

                        setTimeout(() => {
                            updateLine(section, animationLine);
                        }, 300);
                    }
                });
            });

            // // Resize support
            // window.addEventListener('resize', () => {
            //     updateLine(section, animationLine);
            // });
        });
    });
});

window.addEventListener('resize', () => {
    const htsSections = document.querySelectorAll('.horizontal-tabs-section');
    htsSections.forEach(section => {
        const line = section.querySelector('.hts-animation-line');
        updateLine(section, line);
    });
});

function syncActiveTab(section, swiper) {
    const slides = section.querySelectorAll('.hts-tab-item');
    const activeIndex = swiper.activeIndex;

    slides.forEach(slide => slide.classList.remove('is-active'));

    const activeSlide = slides[activeIndex];
    if (!activeSlide) {return;}

    activeSlide.classList.add('is-active');

    const targetId = activeSlide.getAttribute('data-href');
    if (targetId) {
        activateTabContent(section, targetId);
    }
}

function updateLine(section, line) {
    if (!line) {
        return;
    }

    const activeSlide = section.querySelector('.hts-tab-item.is-active');
    if (!activeSlide) {
        return;
    }

    moveLine(activeSlide, line);
}

function moveLine(slide, line) {
    if (!line) {
        return;
    }

    // Target text (centered)
    const target = slide.querySelector('*') || slide;

    const targetRect = target.getBoundingClientRect();
    const lineParentRect = line.parentElement.getBoundingClientRect();

    const width = targetRect.width;
    const left =
        targetRect.left -
        lineParentRect.left +
        (width - line.offsetWidth) / 2;

    line.style.transform = `translateX(${left}px)`;
}

function activateTabContent(section, id) {
    const contents = section.querySelectorAll('.hts-tab-left-wrap');
    const images = section.querySelectorAll('.hts-tab-image');

    contents.forEach(el => {
        if (el.dataset.id === id) {return;} // skip the one we want to fade in

        // Fade out currently visible tab
        fadeOut(el, 300, () => {
            el.classList.remove('aos-animate');

            // If this is the one we want to show, fade it in
            const newEl = section.querySelector(`.hts-tab-left-wrap[data-id="${id}"]`);
            if (newEl) {
                fadeIn(newEl, 300, () => {
                    newEl.classList.add('aos-animate');
                });
            }
        });
    });

    images.forEach(img => {
        if (img.dataset.id === id) {return;} // skip the one we want to fade in

        fadeOut(img, 300, () => {
            img.classList.remove('aos-animate');

            const newImg = section.querySelector(`.hts-tab-image[data-id="${id}"]`);
            if (newImg) {
                fadeIn(newImg, 300, () => {
                    newImg.classList.add('aos-animate');
                });
            }
        });
    });
}
